// extracted by mini-css-extract-plugin
export default {"container":"CollapsibleTitleWithCaret--container--9wPpr"};